
import moment from 'moment'

export default function(options) {
  const from = options.from
  const to = options.to
  const search_text = !!options.searchQuery ? options.searchQuery : undefined
  return {
    page: options.page,
    size: options.pageSize,
    from: from ? moment(from).format('YYYY/MM/DD'): null,
    to: to ? moment(to).format('YYYY/MM/DD'): null,
    page_size: options.pageSize,
  }
}



// WEBPACK FOOTER //
// ./src/transformers/utils/urlParamsTransformer.js